<template>
  <div style="position: relative">
    <section class="mini boxshadow1 part1">
      <div class="breadcrumbs ellipsis" v-if="!_.isEmpty(exporterData)">
        <Tooltip>
          <template v-if="currentQueryType == 'import'">
            <span
              ><span>{{ importerData.name }}</span> 从
              <span>{{ exporterData.name }}</span> 进口
              <span
                >{{ _.truncate(hsData.name, { length: 30 }) }} ({{
                  hsData.code
                }})</span
              ></span
            >
            <div
              slot="content"
              style="text-align:center;font-size:13px;white-space:normal;line-height: 20px;"
            >
              <p>
                <span>{{ importerData.name }}</span> 从
                <span>{{ exporterData.name }}</span> 进口
                <span>{{ hsData.name }} ({{ hsData.code }})</span>
              </p>
            </div>
          </template>
          <template v-else-if="!_.isEmpty(importerData)">
            <span
              ><span>{{ exporterData.name }}</span> 出口 到
              <span>{{ importerData.name }}</span>
              <span
                >{{ _.truncate(hsData.name, { length: 30 }) }} ({{
                  hsData.code
                }})</span
              ></span
            >
            <div
              slot="content"
              style="text-align:center;font-size:13px;white-space:normal;line-height: 20px;"
            >
              <p>
                <span>{{ exporterData.name }}</span> 出口 到
                <span>{{ importerData.name }}</span>
                <span>{{ hsData.name }} ({{ hsData.code }})</span>
              </p>
            </div>
          </template>
        </Tooltip>
      </div>
      <div class="section-content">
        <div class="caption" v-if="currentQueryType == 'import'">
          {{ $t("query.result.rate.compare.title") }}
        </div>
        <div class="caption" v-else>税率信息</div>
        <div class="cell">
          <div class="card-rates">
            <div
              class="card-rate-card"
              v-if="hsData.importTax || currentQueryType == 'import'"
            >
              <div class="card-rate-wrap">
                <div
                  class="besttax"
                  v-if="
                    best &&
                      best.project == 'tax' &&
                      currentQueryType == 'import'
                  "
                >
                  最优
                </div>
                <div class="card-rate-content clearfix">
                  <div class="name" v-if="currentQueryType == 'import'">
                    {{ $t("query.result.rate.compare.gtr") }}
                  </div>
                  <div class="name" v-else>基准税率</div>
                  <div
                    :class="[
                      'value',
                      {
                        multi: $options.filters.isMultiRate(
                          $options.filters.rateValueReturn(
                            hsData.importTax,
                            hsData.importTaxDescription
                          )
                        )
                      }
                    ]"
                  >
                    <RateView
                      :content="
                        $options.filters.rateValueAccording(
                          hsData.importTax,
                          hsData.importTaxDescription
                        )
                      "
                    ></RateView>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="card-rate-card"
              v-if="hsData.importMfnTax || currentQueryType == 'import'"
            >
              <div class="card-rate-wrap">
                <div
                  class="besttax"
                  v-if="
                    best &&
                      best.project == 'mfn' &&
                      currentQueryType == 'import'
                  "
                >
                  最优
                </div>
                <div class="card-rate-content clearfix">
                  <div class="name" v-if="currentQueryType == 'import'">
                    {{ $t("query.result.rate.compare.mfn") }}
                  </div>
                  <div class="name" v-else>RCEP协定税率</div>
                  <div
                    :class="[
                      'value',
                      {
                        multi: $options.filters.isMultiRate(
                          $options.filters.rateValueReturn(
                            hsData.importMfnTax,
                            hsData.importMfnTaxDescription
                          )
                        )
                      }
                    ]"
                  >
                    <RateView
                      :content="
                        $options.filters.rateValueAccording(
                          hsData.importMfnTax,
                          hsData.importMfnTaxDescription
                        )
                      "
                    ></RateView>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-rate-card" v-if="currentQueryType == 'import'">
              <div class="card-rate-wrap">
                <div
                  class="besttax"
                  v-if="best && best.project == 'provisional'"
                >
                  最优
                </div>
                <div class="card-rate-content clearfix">
                  <div class="name">
                    {{ $t("query.result.rate.compare.ifr") }}
                  </div>
                  <div
                    :class="[
                      'value',
                      {
                        multi: $options.filters.isMultiRate(
                          $options.filters.rateValueReturn(
                            hsData.importTaxProvisional,
                            hsData.importTaxProvisionalDescription
                          )
                        )
                      }
                    ]"
                  >
                    <RateView
                      :content="
                        $options.filters.rateValueAccording(
                          hsData.importTaxProvisional,
                          hsData.importTaxProvisionalDescription
                        )
                      "
                    ></RateView>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="currentQueryType == 'import'">
              <div
                class="card-rate-card"
                v-for="(item, index) in dataSet"
                :key="`rate-content-${index}`"
              >
                <div class="card-rate-wrap">
                  <div
                    class="besttax"
                    v-if="
                      best && best.project == 'fta' && best.id == item.ftaId
                    "
                  >
                    最优
                  </div>
                  <div class="card-rate-content clearfix">
                    <div
                      :class="[
                        'name2',
                        { multi: $options.filters.isMultiRate(item.tax) }
                      ]"
                    >
                      <div class="rname">
                        {{ $t("query.result.other.fta") }}
                      </div>
                      <div class="from">
                        <RateView
                          :content="item.name"
                          :strLen="item.name"
                        ></RateView>
                      </div>
                    </div>
                    <div
                      :class="[
                        'value2',
                        { multi: $options.filters.isMultiRate(item.tax) }
                      ]"
                    >
                      <div class="rvalue">
                        <RateView
                          :content="
                            $options.filters.rateValueAccording(
                              item.tax,
                              item.description
                            )
                          "
                        ></RateView>
                      </div>
                      <a
                        href="#"
                        @click.stop.prevent="
                          jfNotice($event, {
                            name: 'queryRules',
                            params: {
                              exporter: exporterID,
                              importer: importerID,
                              hscode: hscode
                            },
                            query: { tab: item.ftaId, text: exporterData.name }
                          })
                        "
                      >
                        {{ $t("query.result.rate.compare.queryRules") }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="card-rate-card" v-if="currentQueryType == 'import'">
              <div class="card-rate-wrap" v-if="_.isEmpty(dataSet)">
                <div class="card-rate-content clearfix">
                  <div class="name2">
                    <div class="rname">{{ $t("query.result.other.fta") }}</div>
                    <div class="from" style="color:#fff">
                      {{ $t("query.result.rate.nofta") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <template v-if="!_.isEmpty(recommendItem)">
      <div class="recommend clearfix" v-show="isShowRem">
        <div class="cursor" @click="goRecommmend(recommendItem.rk.exporter.id)">
          <div class="title">{{ $t("query.result.rate.recommend.title") }}</div>
          <div
            class="from"
            v-html="
              $t('query.result.rate.recommend.from', {
                from: recommendItem.rk.exporter.name,
                to: importerData.name
              })
            "
          ></div>
          <div class="value">
            {{ recommendItem.tax }}<span class="unit">%</span>
            <span class="saveupto"
              >({{ $t("query.result.rate.recommend.saveup") }}
              {{ recommendItem.saveto }}<span class="unit">%</span>)</span
            >
          </div>
        </div>
      </div>
    </template>

    <div class="part2" v-if="currentQueryType == 'import'">
      <div class="relfta">
        <div class="relfta-wrap mini boxshadow1">
          <div class="caption">其他国家和地区FTA</div>
          <div class="cell">
            <OtherFta
              ref="sider"
              class="oftaRef"
              currentQueryType="import"
              :ranks="ranks"
              :exporterID="exporterID"
              :importerID="importerID"
              :hscode="hscode"
            ></OtherFta>
          </div>
        </div>
      </div>

      <div class="relrate mini boxshadow1" style="margin-top:20px">
        <div class="caption">增值-消费税率</div>
        <div class="cell">
          <Row :gutter="20">
            <Col span="12">
              <div class="relbox">
                <div class="title">
                  {{ $t("query.result.rate.related.avtr") }}
                </div>
                <div class="value">
                  <RateView
                    :content="
                      $options.filters.rateValueConver(hsData.taxAddedValue)
                    "
                  ></RateView>
                </div>
              </div>
            </Col>

            <Col span="12">
              <div class="relbox">
                <div class="title">
                  {{ $t("query.result.rate.related.ctr") }}
                </div>
                <div class="value">
                  <RateView
                    :content="
                      $options.filters.rateValueConver(hsData.taxExcise)
                    "
                  ></RateView>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="relrate mini boxshadow1" style="margin-top:20px">
        <div class="caption">中美加征</div>
        <div class="cell">
          <Row :gutter="20">
            <Col span="8">
              <div class="relbox">
                <div class="title">
                  加征税率
                </div>
                <div class="value">
                  <RateView
                    :content="$options.filters.rateValueConver(levyData.levy)"
                  ></RateView>
                </div>
              </div>
            </Col>

            <Col span="8">
              <div class="relbox">
                <div class="title">
                  暂停加征开始时间
                </div>
                <div class="value">
                  <RateView
                    :content="
                      $options.filters.rateValueConver(levyData.startTime)
                    "
                  ></RateView>
                </div>
              </div>
            </Col>
            <Col span="8">
              <div class="relbox">
                <div class="title">
                  暂停加征结束时间
                </div>
                <div class="value">
                  <RateView
                    :content="
                      $options.filters.rateValueConver(levyData.endTime)
                    "
                  ></RateView>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>

    <Statement></Statement>
  </div>
</template>

<script>
import Vue from "vue";
import Statement from "@/components/layout/statement";
import { createNamespacedHelpers } from "vuex";
import Velocity from "velocity-animate";
// eslint-disable-next-line

import RateSider from "../RateSider";
import OtherFta from "./OtherFta";
import RelatedNews from "./News";

import RateView from "@/components/query/common/RateView";
import G2 from "@antv/g2";
G2.track(false);
const { mapGetters: mapDataGetters } = createNamespacedHelpers("data");

export default {
  name: "RateContent",
  components: {
    RateSider,
    OtherFta,
    RelatedNews,

    RateView,
    Statement
  },
  props: {
    currentQueryType: String,
    // fandata: {
    //   type: Array,
    //   default: () => [],
    //   required: false
    // },

    fantotalPage: {
      type: Number,
      default: () => 0,
      required: false
    },
    fanpage: {
      type: Number,
      default: () => 1,
      required: false
    },
    hsData: {
      type: Object,
      default: () => {
        return {};
      },
      required: false
    },
    levyData: {
      type: Object,
      default: () => {
        return {};
      },
      required: false
    },
    exporterData: {
      type: Object,
      default: () => {
        return {};
      },
      required: false
    },
    importerData: {
      type: Object,
      default: () => {
        return {};
      },
      required: false
    },
    dataSet: {
      type: Array,
      default: () => [],
      required: false
    },
    ranks: {
      type: Array,
      default: () => [],
      required: false
    },
    best: {
      type: Object,
      default: () => {
        return {};
      },
      required: false
    },
    exporterID: {
      type: [String, Number]
    },
    importerID: {
      type: [String, Number]
    },
    hscode: {
      type: [String, Number]
    }
  },
  data() {
    return {
      isShowRem: true,
      chart: null,
      tryAmount: 12304,
      tableFtaValue: [],
      currency: "人民币",
      moneyType: "￥"
    };
  },
  computed: {
    recommendItem() {
      if (this.hsData && !this._.isEmpty(this.ranks)) {
        let rateValue = 0;
        if (this.$options.filters.rateIsAvailable(this.hsData.importMfnTax)) {
          if (parseFloat(this.hsData.importMfnTax) > 0) {
            rateValue = parseFloat(this.hsData.importMfnTax);
          }
        } else if (
          this.$options.filters.rateIsAvailable(this.hsData.importTax)
        ) {
          if (parseFloat(this.hsData.importTax) > 0) {
            rateValue = parseFloat(this.hsData.importTax);
          }
        }
        if (!this._.isNaN(rateValue) && rateValue > 0) {
          let dsRate = null;
          if (!this._.isEmpty(this.dataSet)) {
            let ds = this._.sortBy(this.dataSet, v => {
              let taxValue = parseFloat(v.tax);
              return this._.isNaN(taxValue) ? 100000 : taxValue;
            });
            dsRate = parseFloat(ds[0].tax);
            if (this._.isNaN(dsRate)) {
              dsRate = null;
            }
          }
          let rk = this._.find(this.ranks, v => {
            return !this._.isNaN(parseFloat(v.tax));
          });
          if ((dsRate === null || dsRate > 0) && !this._.isEmpty(rk)) {
            if (
              (dsRate === null || dsRate > parseFloat(rk.tax)) &&
              rateValue > parseFloat(rk.tax)
            ) {
              return {
                tax: this._.replace(this._.trim(rk.tax), /%$/, ""),
                saveto: this._.ceil(rateValue - parseFloat(rk.tax), 2),
                rk: rk
              };
            }
          }
        }
      }
      return null;
    },
    isShowChart() {
      if (this.hsData) {
        let rateValue = null;
        if (this.$options.filters.rateIsAvailable(this.hsData.importMfnTax)) {
          rateValue = parseFloat(this.hsData.importMfnTax);
        } else if (
          this.$options.filters.rateIsAvailable(this.hsData.importTax)
        ) {
          rateValue = parseFloat(this.hsData.importTax);
        }
        if (rateValue !== null && !this._.isNaN(rateValue) && rateValue > 0) {
          let ds = this._.filter(this.dataSet, v => {
            return !this._.isNaN(parseFloat(v.tax));
          });
          return !this._.isEmpty(ds);
        }
      }
      return false;
    },
    isShowGraphic() {
      // return this._.find(this.dataSet, (v) => {
      //   return !this._.isNaN(parseFloat(v.tax)) && parseFloat(v.tax) > 0
      // })
      return false;
    },
    tableValue() {
      let items = [];
      let ds = this._.filter(this.dataSet, v => {
        return !this._.isNaN(parseFloat(v.tax));
      });
      let rateValue = null;
      let tariffTitle = this.$t("query.result.other.mfn");
      if (this.$options.filters.rateIsAvailable(this.hsData.importMfnTax)) {
        rateValue = parseFloat(this.hsData.importMfnTax);
      } else if (this.$options.filters.rateIsAvailable(this.hsData.importTax)) {
        rateValue = parseFloat(this.hsData.importTax);
        tariffTitle = this.$t("query.result.rate.compare.gtr");
      }
      if (
        rateValue !== null &&
        !this._.isNaN(rateValue) &&
        !this._.isEmpty(ds)
      ) {
        let tariffValue = this.tryAmount * (rateValue / 100);
        let addTariffRate = null;
        if (this.$options.filters.rateIsAvailable(this.hsData.taxAddedValue)) {
          addTariffRate = parseFloat(this.hsData.taxAddedValue);
          if (this._.isNaN(addTariffRate)) {
            addTariffRate = null;
          }
        }
        let exciseTariffRate = null;
        if (this.$options.filters.rateIsAvailable(this.hsData.taxExcise)) {
          exciseTariffRate = parseFloat(this.hsData.taxExcise);
          if (this._.isNaN(exciseTariffRate)) {
            exciseTariffRate = null;
          }
        }
        let exciseTariffRateValue =
          exciseTariffRate === null
            ? 0
            : (this.tryAmount + tariffValue) * (exciseTariffRate / 100);
        let addTariffRateValue =
          addTariffRate === null
            ? 0
            : (this.tryAmount + tariffValue) * (addTariffRate / 100);
        let mfnItem = {
          title: tariffTitle,
          tariff: this._h.padZeroPlaces(this._h.toThousands(tariffValue, 2)),
          saving: null,
          addTariff: this._h.padZeroPlaces(
            this._h.toThousands(addTariffRateValue, 2)
          ),
          savingAddTariff: null,
          exciseTariff: this._h.padZeroPlaces(
            this._h.toThousands(exciseTariffRateValue, 2)
          ),
          savingExciseTariff: null,
          savingTotal: null,
          tooltip: {
            tariff: {
              title: `${this.$t(
                "query.result.other.goodsValue"
              )} x ${tariffTitle}`,
              value: `${this._h.padZeroPlaces(
                this._h.toThousands(this.tryAmount, 2)
              )} x ${this.$options.filters.addUnit(rateValue)}`
            },
            addTariff: {
              title: `(${this.$t("query.result.other.goodsValue")} + ${this.$t(
                "query.result.other.goodsValue"
              )} x ${tariffTitle}) x ${this.$t(
                "query.result.rate.related.avtr"
              )}`,
              value: `(${this._h.padZeroPlaces(
                this._h.toThousands(this.tryAmount, 2)
              )} + ${this._h.padZeroPlaces(
                this._h.toThousands(this.tryAmount, 2)
              )} x ${this.$options.filters.addUnit(
                rateValue
              )}) x ${this.$options.filters.addUnit(addTariffRate)}`
            },
            exciseTariff: {
              title: `(${this.$t("query.result.other.goodsValue")} + ${this.$t(
                "query.result.other.goodsValue"
              )} x ${tariffTitle}) x ${this.$t(
                "query.result.rate.related.ctr"
              )}`,
              value: `(${this._h.padZeroPlaces(
                this._h.toThousands(this.tryAmount, 2)
              )} + ${this._h.padZeroPlaces(
                this._h.toThousands(this.tryAmount, 2)
              )} x ${this.$options.filters.addUnit(
                rateValue
              )}) x ${this.$options.filters.addUnit(exciseTariffRate || 0)}`
            }
          },
          value: tariffValue,
          addTariffValue: addTariffRateValue,
          exciseTariffValue: exciseTariffRateValue,
          totalValue: tariffValue + addTariffRateValue + exciseTariffRateValue
          // totalValue: 0
        };
        items.push(mfnItem);
        for (let i = 0; i < ds.length; i++) {
          let ftaValue = this.tryAmount * (parseFloat(ds[i]["tax"]) / 100);
          let ftaAddTariffValue =
            addTariffRate === null
              ? 0
              : (this.tryAmount + ftaValue) * (addTariffRate / 100);
          let ftaexciseTariffValue =
            exciseTariffRate === null
              ? 0
              : (this.tryAmount + ftaValue) * (exciseTariffRate / 100);
          let savingFtaTariffValue = tariffValue - ftaValue;
          let savingAddTariffValue =
            this.tryAmount *
            (addTariffRate / 100) *
            (rateValue / 100 - parseFloat(ds[i]["tax"]) / 100);
          let savingExciseTariffValue =
            this.tryAmount *
            (exciseTariffRate / 100) *
            (rateValue / 100 - parseFloat(ds[i]["tax"]) / 100);
          let saving = this._h.padZeroPlaces(
            this._h.toThousands(savingFtaTariffValue, 2)
          );
          let savingAddTariff = this._h.padZeroPlaces(
            this._h.toThousands(savingAddTariffValue, 2)
          );
          let savingExciseTariff = this._h.padZeroPlaces(
            this._h.toThousands(savingExciseTariffValue, 2)
          );
          //重新赋值
          let savingC = savingFtaTariffValue.toFixed(2);
          let savingAddTariffC = savingAddTariffValue.toFixed(2);
          let savingExciseTariffC = savingExciseTariffValue.toFixed(2);
          //重新赋值
          let ftaItem = {
            title: `${this.$options.filters.cleanFTAName(ds[i].name)} ${this.$t(
              "query.result.other.fta"
            )}`,
            tariff: this._h.padZeroPlaces(this._h.toThousands(ftaValue, 2)),
            saving,
            addTariff: this._h.padZeroPlaces(
              this._h.toThousands(ftaAddTariffValue, 2)
            ),
            savingAddTariff,
            exciseTariff: this._h.padZeroPlaces(
              this._h.toThousands(ftaexciseTariffValue, 2)
            ),
            savingExciseTariff,
            savingTotal: this._h.padZeroPlaces(
              this._h.toThousands(
                savingC * 1 + savingAddTariffC * 1 + savingExciseTariffC * 1,
                2
              )
            ),
            tooltip: {
              tariff: {
                title: `${this.$t("query.result.other.goodsValue")} x ${this.$t(
                  "query.result.other.fta"
                )}`,
                value: `${this._h.padZeroPlaces(
                  this._h.toThousands(this.tryAmount, 2)
                )} x ${this.$options.filters.addUnit(ds[i]["tax"])}`
              },
              saving: {
                title: `${this.$t(
                  "query.result.other.goodsValue"
                )} x (${tariffTitle} - ${this.$t("query.result.other.fta")})`,
                value: `${this._h.padZeroPlaces(
                  this._h.toThousands(this.tryAmount, 2)
                )} x (${this.$options.filters.addUnit(
                  rateValue
                )} - ${this.$options.filters.addUnit(ds[i]["tax"])})`
              },
              addTariff: {
                title: `(${this.$t(
                  "query.result.other.goodsValue"
                )} + ${this.$t("query.result.other.goodsValue")} x ${this.$t(
                  "query.result.other.fta"
                )}) x ${this.$t("query.result.rate.related.avtr")}`,
                value: `(${this._h.padZeroPlaces(
                  this._h.toThousands(this.tryAmount, 2)
                )} + ${this._h.padZeroPlaces(
                  this._h.toThousands(this.tryAmount, 2)
                )} x ${this.$options.filters.addUnit(
                  ds[i]["tax"]
                )}) x ${this.$options.filters.addUnit(addTariffRate || 0)}`
              },
              savingAddTariff: {
                title: `${this.$t("query.result.other.goodsValue")} x ${this.$t(
                  "query.result.rate.related.avtr"
                )} x (${tariffTitle} - ${this.$t("query.result.other.fta")})`,
                value: `${this._h.padZeroPlaces(
                  this._h.toThousands(this.tryAmount, 2)
                )} x ${this.$options.filters.addUnit(
                  addTariffRate || 0
                )} x (${this.$options.filters.addUnit(
                  rateValue
                )} - ${this.$options.filters.addUnit(ds[i]["tax"])})`
              },
              exciseTariff: {
                title: `(${this.$t(
                  "query.result.other.goodsValue"
                )} + ${this.$t("query.result.other.goodsValue")} x ${this.$t(
                  "query.result.other.fta"
                )}) x ${this.$t("query.result.rate.related.ctr")}`,
                value: `(${this._h.padZeroPlaces(
                  this._h.toThousands(this.tryAmount, 2)
                )} + ${this._h.padZeroPlaces(
                  this._h.toThousands(this.tryAmount, 2)
                )} x ${this.$options.filters.addUnit(
                  ds[i]["tax"]
                )}) x ${this.$options.filters.addUnit(exciseTariffRate || 0)}`
              },
              savingExciseTariff: {
                title: `${this.$t("query.result.other.goodsValue")} x ${this.$t(
                  "query.result.rate.related.ctr"
                )} x (${tariffTitle} - ${this.$t("query.result.other.fta")})`,
                value: `${this._h.padZeroPlaces(
                  this._h.toThousands(this.tryAmount, 2)
                )} x ${this.$options.filters.addUnit(
                  exciseTariffRate || 0
                )} x (${this.$options.filters.addUnit(
                  rateValue
                )} - ${this.$options.filters.addUnit(ds[i]["tax"])})`
              },
              savingTotal: {
                title: `${this.$t("query.result.rate.es.tb.col2")} + ${this.$t(
                  "query.result.rate.es.tb.col4"
                )} + 节省消费税`,
                value: `${this._h.padZeroPlaces(
                  this._h.toThousands(savingFtaTariffValue, 2)
                )} + ${this._h.padZeroPlaces(
                  this._h.toThousands(savingAddTariffValue, 2)
                )} + ${this._h.padZeroPlaces(
                  this._h.toThousands(savingExciseTariffValue, 2)
                )}`
              }
            },
            value: ftaValue,
            addTariffValue: ftaAddTariffValue,
            exciseTariffValue: ftaexciseTariffValue,
            // totalValue: savingFtaTariffValue + savingAddTariffValue
            totalValue: ftaValue + ftaAddTariffValue + ftaexciseTariffValue
          };
          items.push(ftaItem);
        }
      }
      return items;
    }
  },
  watch: {
    isShowChart(newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          this.renderChart();
        }, 200);
      }
    },
    tableValue(newVal, oldVal) {
      if (newVal) {
        this.tableFtaValue = this._.slice(newVal, 1);
        this.updateChart();
      }
    }
  },
  filters: {
    cleanFTAName(value) {
      return Vue._.trim(Vue._.replace(Vue._.trim(value), /fta$/i, ""));
    },
    getFTALen(value) {
      let winWidth = Vue._h.getWinWidth();
      let hasSpace = /-/.test(value);
      if (winWidth > 1100) {
        return hasSpace ? 8 : 6;
      } else if (winWidth > 1200) {
        return hasSpace ? 10 : 8;
      }
      return hasSpace ? 6 : 4;
    }
  },
  methods: {
    searchAnti2(page) {
      this.$emit("searchAnti2", page);
    },
    jfNotice(event, params) {
      this.GJFNotice(status => {
        if (status) {
          let jf = this.getApiValue()(2);
          if (jf && jf.integral && jf.integral > 0) {
            this.GConfirm(
              `本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`,
              status => {
                if (status) {
                  this.$router.push(params);
                }
              }
            );
          } else {
            this.$router.push(params);
          }
        } else {
          this.$router.push(params);
        }
      });
    },
    ...mapDataGetters(["getApiValue"]),
    tryCal() {
      if (this.$refs.tryModal) {
        this.$refs.tryModal.isShow = true;
      }
    },
    inputAmount(v) {
      this.tryAmount = Math.abs(parseFloat(v.value));
      this.currency = v.currency;
      if (v.currency === "人民币") {
        this.moneyType = "￥";
      } else {
        this.moneyType = "$";
      }
    },
    goRecommmend(recommendExpoterID) {
      this.GJFNotice(status => {
        if (status) {
          let jf = this.getApiValue()(1);
          if (jf && jf.integral && jf.integral > 0) {
            this.GConfirm(
              `本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`,
              status => {
                if (status) {
                  this.$router.push({
                    name: "queryRateI",
                    params: {
                      exporter: recommendExpoterID,
                      importer: this.importerID,
                      hscode: this.hscode
                    }
                  });
                }
              }
            );
          } else {
            this.$router.push({
              name: "queryRateI",
              params: {
                exporter: recommendExpoterID,
                importer: this.importerID,
                hscode: this.hscode
              }
            });
          }
        } else {
          this.$router.push({
            name: "queryRateI",
            params: {
              exporter: recommendExpoterID,
              importer: this.importerID,
              hscode: this.hscode
            }
          });
        }
      });
    },
    updateChart() {
      this.chart && this.chart.changeData(this.getChartData());
    },
    getChartData() {
      let data = [];
      for (let i = 0; i < this.tableValue.length; i++) {
        data.push({
          name: this.tableValue[i].title,
          savaTax: this.$t("query.result.rate.chart.x1"),
          totalSaveTax: this._.ceil(
            parseFloat(this.tableValue[i].value) || 0,
            2
          )
        });
        data.push({
          name: this.tableValue[i].title,
          savaTax: this.$t("query.result.rate.chart.x2"),
          totalSaveTax: this._.ceil(
            parseFloat(this.tableValue[i].totalValue) || 0,
            2
          )
        });
      }
      return data;
    },
    renderChart() {
      if (!this.isShowGraphic) return;
      let data = this.getChartData();
      let fontSize = this._h.getWinWidth() > 1366 ? 11 : 10;
      let graphicWidth = this._h.getRealElSize(
        document.querySelector(".graphic")
      ).width;
      let chartWidth = graphicWidth * 0.7;
      if (chartWidth < 200) chartWidth = 200;
      if (chartWidth > 480) chartWidth = 480;
      let chartHeight = chartWidth * 0.55;
      this.setSummary(graphicWidth, chartWidth);
      this.chart = new G2.Chart({
        container: "chart",
        // forceFit: true,
        width: chartWidth,
        height: chartHeight,
        padding: [30, 20, 60, "auto"]
      });
      // this.chart.forceFit()
      this.chart.source(data);
      // this.chart.tooltip(false)
      this.chart.tooltip({
        crosshairs: {
          type: "rect"
        },
        "g2-tooltip-title": {
          fontSize: fontSize
        },
        "g2-tooltip": {
          fontSize: fontSize
        }
      });
      this.chart.axis("savaTax", {
        title: null,
        label: {
          textStyle: {
            fill: "#999999",
            fontSize: fontSize + 1
          },
          autoRotate: false
        },
        line: {
          stroke: "#D8D8D8",
          lineWidth: 1
        },
        tickLine: null,
        grid: null
      });
      this.chart.axis("totalSaveTax", {
        title: null,
        label: {
          textStyle: {
            fill: "#999999",
            fontSize: fontSize + 1
          },
          formatter: (text, item, index) => {
            // if (index === 6) return null
            if (index === data.length) return null;
            text = this._.trim(text);
            if (text === "0" || this._.isEmpty(text)) {
              return null;
            } else {
              return this._h.padZeroPlaces(this._h.toThousands(text, 2));
            }
          }
        },
        line: {
          stroke: "#D8D8D8",
          lineWidth: 1
        },
        tickLine: null,
        grid: null
      });
      this.chart.legend(false);
      this.chart
        .interval()
        .position("savaTax*totalSaveTax")
        .color("name", "#C3E0FF-#9DCCFF-#1F8AFD")
        .size(33)
        .adjust({
          type: "dodge",
          marginRatio: 0
        });
      this.chart.render();
    },
    setSummary(graphicWidth, chartWidth) {
      let summary = document.querySelector(".graphic .summary");
      if (summary) {
        let left =
          (graphicWidth -
            chartWidth -
            (this._h.getRealElSize(summary).width || 0)) /
          2;
        left = left > 50 ? 50 : left;
        summary.style.left = `${chartWidth + left}px`;
        summary.style.visibility = "visible";
      }
    },
    refresh() {
      this.$refs.sider && this.$refs.sider.refresh();
    },
    remLeave(el, done) {
      Velocity(el, "transition.shrinkOut", {
        duration: 100,
        complete: () => {
          done();
          this.refresh();
        }
      });
    }
  }
  // mounted() {
  //   this.$refs.tryModal.isShow = true;
  // }
};
</script>
<style scoped>
.chris_sd {
  position: absolute;
  width: 100px;
  right: 60px;
  top: -60px;
  z-index: 100;
}
.part {
  /*margin-top: 15px;*/
  position: relative;
  padding-right: 235px;
  margin-bottom: 12px;
}
.part:last-child {
  margin-bottom: 0;
}
.r-main {
}
.cell {
  padding: 0 13px;
  /*font-size: 11px;*/
  font-size: 13px;
}
.r-sidebar {
  position: absolute;
  top: 0;
  right: 0;
  width: 220px;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(223, 223, 223, 0.5);
}
section {
  background-color: #fff;
  /* padding: 20px 18px 25px; */
  box-shadow: 0 2px 4px 0 rgba(223, 223, 223, 0.5);
  margin-bottom: 12px;
}
section.mini {
  /* padding-bottom: 10px; */
}
section:last-child {
  margin-bottom: 0;
}
.section-content {
  padding: 18px 18px 16px;
  /* margin-top: 18px; */
}
.part1 .section-content {
  padding-bottom: 3px;
}
.caption {
  font-size: 16px;
  color: #333;
  background: url("~@/assets/images/home/guide.png") 0 center no-repeat
    transparent;
  background-size: 12px;
  padding-left: 18px;
  margin-bottom: 15px;
  position: relative;
}
.cell {
  padding: 0;
  font-size: 15px;
}
.cell .title {
  color: #333;
  font-size: 15px;
}
.cell .value {
  color: #333;
}
.cell >>> .ivu-row {
  margin-bottom: 10px;
}
.cell >>> .ivu-row:last-child {
  margin-bottom: 0;
}
.cell >>> .ivu-col {
  margin-bottom: 15px;
}
.cell .value .unit {
  color: #666;
  /*font-size: 8px;*/
  font-size: 10px;
  padding-left: 1px;
}
.card-rate {
  margin-bottom: 15px;
}
.card-rates {
  margin-left: -10px;
  margin-right: -10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.card-rate-card {
  width: 20%;
}
.card-rate-wrap {
  margin: 0 10px 20px;
  position: relative;
  background-color: #fff;
  border: 1px solid #ececec;
  box-shadow: 3px 3px 5px 0 rgba(225, 225, 225, 0.5);
  /*height: 66px;*/
  height: 86px;
  max-width: 230px;
  background-color: #8892f3;
  border-radius: 6px;
}
.card-rate-card:nth-child(2n) .card-rate-wrap {
  background-color: #bc8cf0;
}
.card-rate-card:nth-child(3n) .card-rate-wrap {
  background-color: #ffa799;
}
.card-rate-card:nth-child(4n) .card-rate-wrap {
  background-color: #8ac3fa;
}
.card-rate-card:nth-child(5n) .card-rate-wrap {
  background-color: #46cece;
}
.card-rate-content {
  color: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  right: 10px;
}
.card-rate-content .name,
.card-rate-content .name2 {
  float: left;
  font-size: 15px;
}
.card-rate-content .name,
.card-rate-content .name2 {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.card-rate-content .value,
.card-rate-content .value2 {
  float: right;
  font-size: 15px;
  color: #fff;
  font-weight: bold;
}
.card-rate-content .value.multi,
.card-rate-content .value2.multi {
  font-size: 12px;
}
.card-rate-content .value >>> .unit,
.card-rate-content .value2 >>> .unit {
  /*font-size: 9px;*/
  font-size: 11px;
  color: #fff;
}
.card-rate-content .value2 >>> .unit {
  color: #fff;
}
.card-rate-content .value2 {
  text-align: right;
  color: #fff;
}
.card-rate-content .value2 a {
  font-size: 13px;
  color: #fff;
  font-weight: normal;
}
/* .card-rate-content .value2 a:after{
    background-color: #1F8AFD;
  } */
.recommend {
  padding: 0 0 0 45px;
  background: url("~@/assets/images/home/light.png") 18px center no-repeat
    transparent;
  background-size: 20px;
  position: relative;
  font-size: 15px;
  margin-top: 30px;
  /* cursor: pointer; */
}
.cursor {
  cursor: pointer;
}
.recommend .title {
  float: left;
  color: #333;
  /*font-weight: bold;*/
}
.recommend .from {
  float: left;
  color: #151515;
  margin: 0 5px 0 0;
}
.recommend .from >>> span {
  color: #333;
  /*font-weight: bold;*/
  padding: 0 2px;
}
.recommend .value {
  float: left;
  color: #0470e3;
  font-weight: bold;
}
.recommend .saveupto {
  /*font-size: 12px;*/
  font-size: 15px;
}
.recommend .value .unit {
  /*font-size: 9px;*/
  /*font-size: 10px;*/
  font-size: 14px;
}
.recommend .saveupto .unit {
  /*font-size: 10px;*/
  font-size: 14px;
}
.recommend .close {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 15px;
}
.part2 {
  margin-top: 30px;
  position: relative;
}
.part2 .relrate {
  padding: 18px 18px 8px;
  width: 100%;
  background: #fff;
}
.part2 .relrate .cell >>> .ivu-col {
  margin-bottom: 20px;
}
.part2 .relfta,
.part3 .news {
  height: 100%;
  width: 100%;
}
.part2 .relfta-wrap,
.part3 .news-wrap {
  background: #fff;
  padding: 18px 18px 16px;
  height: 100%;
  position: relative;
}
.part2 .relfta .cell,
.part3 .news .cell {
  overflow-x: hidden;
  padding-right: 18px;
  overflow-y: auto;
}
.part2 .relfta .cell::-webkit-scrollbar-track-piece,
.part3 .news .cell::-webkit-scrollbar-track-piece {
  background: transparent;
}
.part2 .relfta .cell::-webkit-scrollbar,
.part3 .news .cell::-webkit-scrollbar {
  width: 4px;
}
.part2 .relfta .cell::-webkit-scrollbar-thumb,
.part3 .news .cell::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 20px;
}
.part3 {
  margin-top: 30px;
  position: relative;
}
.part3 .trycalwrap {
  width: 100%;
}
.part3 .trycalwrap section {
  padding: 18px 18px 8px;
}
.part3 .news .more {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  padding-right: 10px;
  font-size: 13px;
  cursor: pointer;
}
.part3 .news .more:hover {
  color: #0470e3;
}
/* .part3 .news .more::after{
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%);
    background: url("~@/assets/images/home/ar1.png") right center no-repeat transparent;
    background-size: 12px;
  } */
.relbox {
  border: 1px solid #dfdfdf;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 78px;
  padding: 0 10px;
}
.relbox .title {
  color: #666;
}
.relbox .value {
  color: #666;
  font-weight: bold;
}
.table-containter {
  position: relative;
}
.table-containter .border-wrap {
  border: 1px solid #eaf7ff;
  position: absolute;
  top: 0;
  bottom: 9px;
  left: 0;
  width: 100%;
}

.table-wrap {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 3px;
}
.table-wrap::-webkit-scrollbar-track-piece {
  background: transparent;
}
.table-wrap::-webkit-scrollbar {
  height: 6px;
}
.table-wrap::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 20px;
}
.table-wrap table {
  /* width: 1400px; */
}
table {
  width: 100%;
  background-color: #fff;
  /* box-shadow: -2px 0 4px 0 rgba(232,232,232,0.50), 0 -2px 4px 0 rgba(232,232,232,0.50), 2px 0 4px 0 rgba(232,232,232,0.50), 0 2px 4px 0 rgba(232,232,232,0.50); */
  /*font-size: 12px;*/
  font-size: 15px;
  color: #676767;
}
/* table thead{
    box-shadow: 0 2px 4px 0 rgba(232,232,232,0.60);
  } */
table thead th {
  color: #676767;
  font-weight: normal;
  text-align: center;
  padding: 9px 5px;
  /*font-size: 11px;*/
  font-size: 14px;
}
table thead th:first-child,
table tbody td:first-child {
  width: 120px;
}
table tbody tr:hover td {
  /*background-color: #ebf7ff !important;*/
  background-color: rgba(202, 234, 255, 0.4) !important;
}
table tbody tr td {
  /* border-bottom: 1px solid #ececec; */
  text-align: center;
  padding: 9px 0;
}
table tbody tr td:first-child {
  font-size: 15px;
}
table tbody tr:last-child td {
  border-bottom: 0;
}
table tbody tr:nth-child(odd) td {
  /* background-color: #F8F8F8; */
}
table tbody tr:nth-child(odd) td:first-child {
  /* background-color: #fff; */
}
.table-wrap .tcontent tr:nth-child(odd) td {
  background-color: #eaf7ff;
}
.table-wrap .tcontent tr td:nth-child(n + 2) {
  color: #989898;
}
table .falling,
.summary .falling {
  /*display: inline-block;*/
  height: 10px;
  background: url("~@/assets/images/icons/show/falling.png") 0 center no-repeat
    transparent;
  background-size: auto 10px;
  padding-left: 6px;
}
.graphic {
  margin-top: 0;
  position: relative;
  margin-bottom: 15px;
}
.chart-wrap {
  position: relative;
  float: left;
}
.chart-legend {
  position: absolute;
  right: 15%;
}
.chart-legend li {
  float: left;
  /*font-size: 1.1rem;*/
  font-size: 1.3rem;
  margin-right: 20px;
  color: #999;
  position: relative;
  padding-left: 18px;
}
.chart-legend li:last-child {
  margin-right: 0;
}
.chart-legend li i,
.summary li i {
  display: block;
  width: 12px;
  height: 5px;
  background-color: #c3e0ff;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.chart-legend li.l2 i,
.summary li.l2 i {
  background-color: #9dccff;
}
.chart-legend li.l3 i,
.summary li.l3 i {
  background-color: #1f8afd;
}
.summary {
  color: #333;
  font-size: 14px;
  bottom: 50px;
}
.summary .title {
  padding-left: 18px;
  color: #666;
}
.summary li {
  position: relative;
  padding: 7px 0;
  padding-left: 20px;
  border-bottom: 1px solid #ececec;
}
.summary li i {
  height: 5px;
  width: 12px;
}
.summary .falling {
  float: right;
  background-image: url("~@/assets/images/icons/show/falling2.png");
  padding-left: 0;
  padding-right: 7px;
  background-position: right center;
  display: inline-block;
  height: 100%;
  color: #1f8afd;
  /*font-weight: bold;*/
}
.summary .falling .unit {
  /*font-size: 8px;*/
  font-size: 10px;
  padding-right: 1px;
}
.cal-btn {
  border: 0.5px solid #8892f4;
  /*border-radius: 100px;*/
  border-radius: 30px;
  color: #8892f4;
  padding: 5px 0;
  text-align: center;
  width: 150px;
  margin: 16px auto 16px;
  cursor: pointer;
}
.cal-btn:hover {
  color: #83bdfc;
  border-color: #83bdfc;
}
table >>> .ivu-tooltip .ivu-tooltip-inner p {
  /*font-size: 11px;*/
  font-size: 13px;
  line-height: 20px;
}
.breadcrumbs {
  /*font-size: 12px;*/
  font-size: 14px;
  color: #333;
  /* width: 90%; */
  /* margin: 0 0 18px; */
  padding: 14px 18px;
  border-bottom: 1px solid #ccc;
}
.breadcrumbs >>> span span {
  color: #0470e3;
  font-weight: bold;
  cursor: default;
}
.boxshadow1 {
  box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
}
.besttax {
  background-color: #f5d82b;
  position: absolute;
  font-size: 12px;
  padding: 0 5px;
  border-radius: 3px;
  right: 0;
  top: 0;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/query/zh-CN/RateLevy.vue